import React, { ReactElement } from 'react';
import { Flex } from 'rebass/styled-components';

import { FloatLabelInput, ButtonGroup } from 'ui/patterns';
import { CustomDatePicker } from 'ui/components';

import Icon from 'assets/icons';

import { TableHeaderProps } from './aboutTypes';

export default function TableHeader(props: TableHeaderProps): ReactElement {
  const onChangeText = (value: string) => {
    props.headerUpdateCallBack &&
      props.headerUpdateCallBack({ columnId: props.column.id, value });
  };

  let sortedItem;
  if (props.multiSortedItem instanceof Array) {
    sortedItem = props.multiSortedItem.find(
      mItem => mItem.sortKey === props.column.id,
    );
  } else {
    sortedItem = props.multiSortedItem;
  }

  if (props.sortedItem) {
    sortedItem = props.sortedItem;
  }

  const onSortChange = () => {
    props.handleSortChange && props.handleSortChange(props.column.id);
  };

  return (
    <Flex>
      {props.column.id !== 'Updated At' ? (
        <FloatLabelInput
          style={{ flexGrow: '1' }}
          label={props.column.id}
          onChangeText={onChangeText}
          value={
            props.columnsSearch && props.columnsSearch[props.column.id]
              ? props.columnsSearch[props.column.id]
              : ''
          }
        />
      ) : (
        <CustomDatePicker
          label="Updated At"
          onChange={(value: any) => {
            props.headerUpdateCallBack &&
              props.headerUpdateCallBack({ columnId: props.column.id, value });
          }}
          value={
            props.columnsSearch && props.columnsSearch[`Updated At`]
              ? props.columnsSearch[`Updated At`]
              : ''
          }
        />
      )}
      <ButtonGroup onClick={onSortChange}>
        {sortedItem?.sortKey !== props.column.id && <Icon.Sort title="Sort" />}
        {sortedItem?.sortKey === props.column.id &&
          sortedItem?.sortOrder === 'asc' && <Icon.SortUp title="Sort" />}
        {sortedItem?.sortKey === props.column.id &&
          sortedItem?.sortOrder === 'desc' && <Icon.SortDown title="Sort" />}
      </ButtonGroup>
    </Flex>
  );
}
